<mat-sidenav-container class="sidenav-container" hasBackdrop="false">
	<mat-sidenav class="side-menu" #sidenav mode="side">
		<button type="button" class="menu-close-btn" (click)="closeSide()">
			<span class="material-icons toggle-icon open">menu_open</span>
		</button>

		<mat-nav-list *ngIf="homeItem">
			<a mat-list-item [routerLink]="homeItem.url" title="{{homeItem.title ? homeItem.title : homeItem.name}}"><strong>{{homeItem.name}}</strong></a>
			<mat-divider></mat-divider>
		</mat-nav-list>

		<mat-nav-list [ngClass]="{ 'has-home-link': homeItem }">
			<ng-container *ngFor="let item of menuItems; last as isLast">
				<a mat-list-item [routerLink]="item.url" routerLinkActive="active" title="{{item.title ? item.title : item.name}}">{{item.name}}</a>
				<mat-divider *ngIf="!isLast"></mat-divider>
			</ng-container>
		</mat-nav-list>
	</mat-sidenav>
	<mat-sidenav-content>
		<button
			type="button"
			class="menu-open-btn"
			[ngClass]="{ open: sideMenuOpen }"
			(click)="openSide()"
		>
			<span class="material-icons toggle-icon">menu</span>
		</button>
		<ng-content></ng-content>
	</mat-sidenav-content>
</mat-sidenav-container>
